import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllStudentsNotPaginatedUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllStudentsNotPaginated
  implements GetAllStudentsNotPaginatedUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllStudentsNotPaginatedUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllStudentsNotPaginatedUseCaseInterface.Params,
  ): Promise<GetAllStudentsNotPaginatedUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}/0`, params),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
